import { render, staticRenderFns } from "./CreateOrganisationDialog.vue?vue&type=template&id=5f3353aa&"
import script from "./CreateOrganisationDialog.vue?vue&type=script&lang=js&"
export * from "./CreateOrganisationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports